import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import CustomButton from "../Buttons/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch } from "react-redux";
import { unlockUserAccount } from "../../store/actions/userManagement/unlockUserAccount";

const ConfirmUnlockAccountModal = ({ open, onClose, userId, setShowModal }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleUnlock = () => {
    setLoading(true);
    dispatch(
      unlockUserAccount({
        userId,
        callback: () => {
          setShowModal(false);
          setLoading(false);
        },
        failed: () => {
          setLoading(false);
        },
      })
    );
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 540,

          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            top: 19,
            right: 10,
          }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <img
            src="/Assets/approveIcon.png"
            alt=""
            className="w-12 h-12 mb-5"
          />
          <div>
            <h1 className="font-semibold text-2xl mb-4">Unlock User Account</h1>
            <p className="text-sm mb-4">
              Are you sure you want to unlock this account?
            </p>

            <div className="flex mt-6 w-full items-center">
              <CustomButton
                variant="outlined"
                customColor="#fff"
                children="Cancel"
                width="100%"
                height="44px"
                borderColor="#D0D5DD"
                color="#344054"
                iconWidth="22px"
                margin="0px 25px 0px 0px"
                onClick={onClose}
              />

              <CustomButton
                variant="contained"
                customColor="#159AA8"
                children={"Yes"}
                width="100%"
                height="44px"
                loading={loading}
                padding="10px"
                color={"#fff"}
                onClick={handleUnlock}
              />
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmUnlockAccountModal;
